import React, { useEffect, useState } from 'react';
import { Button, Col, Dropdown, Modal, Tab } from 'react-bootstrap';
import Loader from '../Shared/Loader';
import { ShortTeamsData } from 'components/Customers/types';
import Alerting from './Alerting';

export default ({ teamsData } : { teamsData: Array<ShortTeamsData> }) => {
    const loaderProps = {
      style: { height: 'calc(100% - 60px)', backgroundColor: 'white', opacity: '1', zIndex: 901 }
    };
    return (
      <Col sm={9}>
        <Tab.Content>
          {teamsData.map((team: ShortTeamsData) => {
            return (<Tab.Pane eventKey={team.teamId} key={'tab-pane' + team.teamId}>
            <div className="customer-b-01">
              <div className="b-customer" style={{ paddingBottom: '0' }}>
                <div className="title-c">
                  <div className="team-tt">
                    <img src={`/assets/images/logos/${team.teamAbbrName}.png`} alt="" height="30px" />
                    {`${team.teamAbbrName} ${team.teamNick}`}
                  </div>
                </div>
              </div>
              <div className="customer-title-players">
                <Loader {...loaderProps} />
                  <div className="title-b">
                    Players
                  </div>
                  <div style={{ width: '974px' }} >
                    <Alerting teamId={team.teamId} league={team.league} />
                  </div>
              </div>
            </div>
            </Tab.Pane>);
          })}
        </Tab.Content>
      </Col>
    );
  };
  